import { useEffect, useState } from "react";
import axios from "axios";

// Resolve user_banking_details.bank_country_id (and corporate_bank_country_id)
// to a country name for display. NULL means the row was saved before the
// international bank step existed — by convention a Canadian account.
export function bankCountryLabel(countries, id) {
  if (!id) return "Canada";
  const match = countries?.find?.((c) => String(c.id) === String(id));
  return match?.country_name || `Country #${id}`;
}

// One-shot public countries list (same endpoint Viewuser already uses).
export function useCountries() {
  const [countries, setCountries] = useState([]);
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API + "get-country")
      .then((res) => setCountries(res?.data?.data || []))
      .catch((err) => console.log(err));
  }, []);
  return countries;
}
